<script setup lang="ts">
import { onMounted, ref } from "vue";
import { SalesRep } from "../../../types/models";
import IconComponent from "../../../components/ui/common/IconComponent.vue";
import { api } from "../../../api/Api";
import Toast from "../../../services/Toast";
import AsyncImage from "../../../components/ui/form/AsyncImage.vue";
import ModalFormTemplate from "./ModalFormTemplate.vue";

const emit = defineEmits<{
  (e: "close"): void;
  (e: "select", rep: SalesRep): void;
}>();

const salesReps = ref<SalesRep[]>([]);

onMounted(() => {
    handleGetSalesReps()
});

const handleGetSalesReps = async () => {
  const response = await api.post(
    "revenue/master-data/sales-reps/get"
  );
  if (response.success == true) {
    salesReps.value = response.data.data;
  } else {
    Toast.show("No Sales Reps found", "warning");
  }
};
const handleSelect = (rep: SalesRep) => {
  emit("select", rep);
  emit('close')
};
</script>

<template>
  <ModalFormTemplate
    mode="create"
    title="Sales Reps"
    endPoint="endPoint"
    :ignore-permission="true"
    :perm="[]"
    :tabList="[]"
    @close="$emit('close')"
    width="45rem"
  >
    <template #form>
      <div>
        <div class="overflow-x-auto overflow-y-auto max-h-[500px]">
          <table class="w-full">
            <thead class="bg-white dark:bg-gray-900">
              <tr>
                <th
                  class="z-20 px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase whitespace-nowrap"
                >
                  Photo
                </th>
                <th
                  class="z-20 px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase whitespace-nowrap"
                >
                  Code
                </th>
                <th
                  class="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase whitespace-nowrap"
                >
                  Name
                </th>
                <th
                  class="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase whitespace-nowrap"
                >
                  Mobile
                </th>
                <th></th>
              </tr>
            </thead>
            <tbody class="divide-y divide-gray-200 dark:divide-gray-700">
              <template
                v-for="rep in salesReps"
                :key="rep.id"
                v-if="salesReps.length > 0"
              >
                <tr @dblclick="handleSelect(rep)">
                    <td class="z-10 px-4 py-3 w-[100px] min-w-20">
                    <AsyncImage :src="rep.profile_photo" :alt="rep.name" />
                  </td>
                  <td class="z-10 px-4 py-3 w-[100px] min-w-20">
                    {{ rep.code }}
                  </td>
                  <td class="px-4 py-3 min-w-80">{{ rep.name }}</td>
                  <td class="px-4 py-3">{{ rep.mobile }}</td>
                  <td class="sticky right-0 z-10 bg-white dark:bg-gray-900 px-4 py-3">
                      <button
                        @click="handleSelect(rep)"
                        class="text-red-600 hover:text-red-700 dark:text-red-400 dark:hover:text-red-300"
                      >
                        <IconComponent name="Hand" />
                      </button>
                    </td>
                </tr>
              </template>
              <tr v-else>
                <td class="w-full text-center p-6" colspan="7">There are no Sales Reps ....</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </template>
  </ModalFormTemplate>
</template>
